__turbopack_context__.v({
  "card": "Compliance-module__cN4d8W__card",
  "cardIcon": "Compliance-module__cN4d8W__cardIcon",
  "cardText": "Compliance-module__cN4d8W__cardText",
  "cardTitle": "Compliance-module__cN4d8W__cardTitle",
  "description": "Compliance-module__cN4d8W__description",
  "grid": "Compliance-module__cN4d8W__grid",
  "header": "Compliance-module__cN4d8W__header",
  "kicker": "Compliance-module__cN4d8W__kicker",
  "section": "Compliance-module__cN4d8W__section",
  "title": "Compliance-module__cN4d8W__title",
});
